if (!customElements.get('w-instagram-feed')) {
  customElements.define('w-instagram-feed', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.videos = [...this.querySelectorAll('video')];
      if (!this.videos.length || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const play = video => video.play().catch(() => {});

      if (matchMedia('(hover: hover)').matches) {
        this.videos.forEach(video => {
          const tile = video.closest('a');
          tile.addEventListener('mouseenter', () => play(video), options);
          tile.addEventListener('mouseleave', () => video.pause(), options);
        });
        return;
      }

      // Touch screens: only the tile most in view plays, to keep data use down.
      const ratios = new Map();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => ratios.set(entry.target, entry.intersectionRatio));
        let active = null;
        ratios.forEach((ratio, video) => { if (ratio >= .75 && (!active || ratio > ratios.get(active))) active = video; });
        this.videos.forEach(video => (video === active ? play(video) : video.pause()));
      }, { threshold: [0, .75, 1] });
      this.videos.forEach(video => this.observer.observe(video));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.videos?.forEach(video => video.pause());
    }
  });
}
